import { extendTheme } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      50: '#eef5f9',
      100: '#d6e5f0',
      200: '#b0cce1',
      300: '#8ab3d2',
      400: '#639ac3',
      500: '#4a81aa',
      600: '#39658a',
      700: '#2b4b68',
      800: '#1c3246',
      900: '#0c1923',
    },
  },
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  radii: {
    md: '10px',
    lg: '16px',
  },
  shadows: {
    outline: '0 0 0 3px rgba(74, 129, 170, 0.6)',
    md: '0 4px 6px rgba(160, 174, 192, 0.15)',
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode('gray.50', 'gray.900')(props),
        color: mode('gray.800', 'gray.100')(props),
      },
    }),
  },
});

export default theme;
